import { Box, Modal, useTheme,Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import AuthGuard from "../../components/AuthGuard";
import Form from "./form";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";

const Role = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [showModal,setShowModal] = useState(false)
  const [rolesDate,setRolesData] = useState([])
  const [cookies,setCookie] = useCookies(['token'])

  const fetchRoles = async()=>{
    const data = await fetch(process.env.REACT_APP_BACKEND_URL+"/role/all",{headers:{
      Authorization:"Bearer "+cookies['token']
    }})
    if(data.status!==200){
      setCookie("token",null)
      return
    }
    const json = await data.json()
    setRolesData(()=>{
      return json.map((role,ind)=>({...role,name:role.name,description:role.description,no:ind+1}))
    })
  }
  useEffect(()=>{
    fetchRoles()
    
  },[])
  const columns = [
    { field: "no", headerName: "No" },
    {
      field: "name",
      headerName: "Role",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
    }
  ];

  const callBackAfterSubmit = ()=>{
    fetchRoles().then(()=>{
        setShowModal(false)
    })
  }

  return (
    <AuthGuard>
    <Box m="10px">
    <Modal open={showModal} onClose={()=>setShowModal(false)}>
      <Form callBackAfterSubmit={callBackAfterSubmit}/>
    </Modal>
    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
      <Header subtitle="Manage Roles" />
      {/* <Button variant="contained" sx={{height:"2rem",width:"10rem",boxSizing:"border-box",background:"#1A8D90",color:"#fff"}} onClick={()=>setShowModal(true)}>
                Add Role
        </Button> */}
      </Box>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          '& .MuiDataGrid-row:nth-child(odd)': {
            border: "1px solid white !important",
            backgroundColor: theme.palette.mode === 'light' ? colors.white[300] : "#F3F5F8",
          },
          '& .MuiDataGrid-iconSeparator': {
            display: 'none',
          },
          "& .MuiDataGrid-root": {
            border: "1px solid white",
          },
          "& .MuiDataGrid-row": {
            border: "1px solid white",

          },
          "& .MuiDataGrid-cell": {
            fontSize: 15,
            color: colors.black[500],
            border: "none !important",

          },
          "& .name-column--cell": {
            fontWeight: "bold",
            color: colors.black[500],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.white[500],
            color: colors.black[900],
            fontSize: 20,
            border: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: "normal",
            fontWeight: "bold",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[500],
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: colors.white[500],
            border: "none",

          },
          "& .MuiDataGrid-pagination": {
            "& .MuiTablePagination-menuItem": {
              color: "#000000",
            },
          },
          "& .MuiTablePagination-root": {
            color: "#000000",
          },
          "& .MuiSvgIcon-root ": {
            color: "#000000",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            left: "75%", 
            transform: `translateX(-75%)`,
            color: `${colors.black[500]} !important`,
          },
          "& .MuiCheckbox-root": {
            color: `${colors.black[500]} !important`,
          },
            "& .MuiDataGrid-row:hover": {
            backgroundColor: "none",
            },
        }}
      >
        <DataGrid rows={rolesDate} columns={columns} />
      </Box>
    </Box>
    </AuthGuard>
  );
};

export default Role;
